import { Button, Text } from "native-base";
export const columns = (navigate) => [
    {
        name: 'Role',
        selector: (row) => row.role.split(' ')[1],
        sortable: true,
    },
    {
        name: 'Name',
        selector: (row) => row.name,
        sortable: true,
    },
    {
        name: 'Phone Number',
        selector: (row) => row.phone_number,
        sortable: true,
    },
    {
        name: 'Stores',
        selector: (row) => row.store_id?.length,
        sortable: true,
    },
    {
        name: 'Verified',
        button: true,
        cell: (row) => <Text
            color={row.verified ? 'green.500' : 'red.500'}
        >{row.verified ? 'Verified' : "Not-Verified"}</Text>,
        sortable: true,
    },
    {
        name: 'Actions',
        button: true,
        cell: (row) => <Button
            size='sm' variant={'link'}
            onPress={() => navigate(`/admin/stores/authorities/edit/${row._id}`)}>
            Edit</Button>,
        sortable: false,
    },
] 